export enum TagType {
  User = 0,
  Company = 1,
}

export interface TagModel {
  id: string;
  company_id: string | null;
  name: string | null;
  type: TagType;
}
